import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import noop from '../../../../utils/noop';
import { useStream } from '../../../../utils/hooks/useStream';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { getCommentableTypeForDeviationType } from '../../../../DeviationPage/redux/helpers';
import Comment from '@wix/da-ds/pkg/Icons/24x24/Comment';
import LoadingIndicator from '../../../../LoadingIndicator';
import { getStreamId } from '../../../../CommentThread/helpers';
import ThreadStack from '../../../../CommentThread/_partials/ThreadStack';
import ThreadPostbox from '../../../../CommentThread/_partials/ThreadPostbox';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import s from './FeedCardCommentThread.scss';
var COMMENT_COUNT_TO_SHOW_BOTTOM_POST = 5;
var FeedCardCommentThread = function (props) {
    var deviation = props.deviation, className = props.className, isThreadOpen = props.isThreadOpen, withCommentSuggestions = props.withCommentSuggestions, _a = props.openCommentThread, openCommentThread = _a === void 0 ? noop : _a, _b = props.showGenericNotification, showGenericNotification = _b === void 0 ? noop : _b;
    var t = useTranslation().t;
    var commentableTypeId = getCommentableTypeForDeviationType(deviation.typeId);
    var commentableItemId = deviation.deviationId;
    var commentStreamId = getStreamId(commentableTypeId, commentableItemId);
    var streamData = useStream(commentStreamId);
    var items = streamData.items, hasMore = streamData.hasMore, isFetching = streamData.isFetching, fetchMore = streamData.fetchNext;
    var itemCount = items.length;
    // we have three sorts of comments to deal with here:
    // comments that are displayed
    // comments that the viewer published that are only saved locally
    // comments that are still on the server and haven't been fetched yet
    var openAndFetchMore = useCallback(function () {
        !isThreadOpen && openCommentThread();
    }, [isThreadOpen, openCommentThread]);
    var _c = useState(0), numCommentsPosted = _c[0], setNumberOfCommentsPosted = _c[1];
    var onPublishSuccess = useCallback(function () {
        setNumberOfCommentsPosted(function (posts) { return posts + 1; });
        openAndFetchMore();
    }, [openAndFetchMore]);
    var totalCommentsShown = itemCount + numCommentsPosted;
    useEffect(function () {
        isThreadOpen && hasMore && fetchMore();
    }, [isThreadOpen, hasMore, fetchMore]);
    if (!deviation.isCommentable) {
        return null;
    }
    var isBottomPostboxVisible = itemCount >= COMMENT_COUNT_TO_SHOW_BOTTOM_POST;
    // this can happen when we load the post in duperbrowse and return to the feed
    var weHaveCommentsNotDisplayed = !isThreadOpen && itemCount > 0;
    return (React.createElement("div", { className: className },
        React.createElement(ThreadPostbox, { isSmall: true, position: "topmost", className: s['commentbox'], commentableItemId: commentableItemId, commentableTypeId: commentableTypeId, withCommentSuggestions: withCommentSuggestions, onPublishSuccess: onPublishSuccess }),
        isThreadOpen && (React.createElement(React.Fragment, null,
            React.createElement(ThreadStack, { className: s['thread-stack'], commentableItemId: commentableItemId, commentableTypeId: commentableTypeId, maxCommentsShown: totalCommentsShown }),
            isFetching && React.createElement(LoadingIndicator, { view: "llama" }),
            isBottomPostboxVisible && (React.createElement(ThreadPostbox, { isSmall: true, position: "bottom", className: s['commentbox'], commentableItemId: commentableItemId, commentableTypeId: commentableTypeId, withCommentSuggestions: withCommentSuggestions, onPublishSuccess: function () {
                    // if we're in the lower box, we show a notification
                    // so the user won't have to scroll up to see if it's posted
                    showGenericNotification({
                        message: t('comment.info.posted'),
                        cardProps: { iconComponent: Comment },
                    });
                    onPublishSuccess();
                } })))),
        (hasMore || weHaveCommentsNotDisplayed) && (React.createElement(TextButton, { className: s['load-more'], variant: "main", size: "medium", onClick: isThreadOpen ? fetchMore : openAndFetchMore, disabled: isFetching, biData: {
                evid: BiEventType.LOAD_MORE_COMMENTS_CLICK,
                itemid: commentableItemId,
                typeid: commentableTypeId,
            }, noHorizontalPaddings: false }, t(isThreadOpen
            ? 'deviationview.feed.viewMoreComments'
            : 'deviationview.feed.viewComments')))));
};
FeedCardCommentThread.displayName = 'FeedCardCommentThread';
export default FeedCardCommentThread;
//# sourceMappingURL=FeedCardCommentThread.js.map